import { useEffect, useState } from "react";
import { Cookie, X } from "lucide-react";

const KEY = "rok_cookie_consent";

export const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setShow(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  useEffect(() => {
    const handler = () => setShow(true);
    window.addEventListener("open-cookie-consent", handler);
    return () => window.removeEventListener("open-cookie-consent", handler);
  }, []);

  const decide = (value) => {
    localStorage.setItem(KEY, value);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      className="fixed inset-x-3 bottom-3 z-[60] mx-auto max-w-3xl animate-[fadeUp_0.5s_ease] sm:inset-x-6"
      data-testid="cookie-consent"
    >
      <div className="relative overflow-hidden rounded-2xl border border-white/10 bg-navy p-5 shadow-2xl shadow-black/40 sm:p-6">
        <div className="absolute -right-8 -top-8 h-28 w-28 rounded-full bg-gold/15 blur-2xl" />
        <button
          onClick={() => decide("dismissed")}
          className="absolute right-3 top-3 text-white/50 transition-colors hover:text-white"
          data-testid="cookie-close"
          aria-label="Dismiss"
        >
          <X size={18} />
        </button>

        <div className="relative flex flex-col gap-4 sm:flex-row sm:items-center">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-gold text-navy">
            <Cookie size={24} />
          </span>
          <div className="flex-1">
            <p className="font-display text-base font-bold text-white">We value your privacy</p>
            <p className="mt-1 text-sm leading-relaxed text-white/70">
              We use cookies to enhance your browsing experience, analyse site traffic and improve our
              shipping services. By clicking “Accept”, you consent to our use of cookies.{" "}
              <a href="/cookie-policy" className="font-semibold text-gold underline underline-offset-2">
                Learn more
              </a>
              .
            </p>
          </div>
          <div className="flex shrink-0 gap-2">
            <button
              onClick={() => decide("declined")}
              data-testid="cookie-decline"
              className="rounded-xl border border-white/20 px-5 py-2.5 text-sm font-bold text-white transition-colors hover:bg-white/10"
            >
              Decline
            </button>
            <button
              onClick={() => decide("accepted")}
              data-testid="cookie-accept"
              className="rounded-xl bg-brandred px-6 py-2.5 text-sm font-bold text-white shadow-lg shadow-brandred/30 transition-transform hover:bg-brandred-700 active:scale-95"
            >
              Accept
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
